import axios from "axios";
import { toast } from "react-toastify";
import {
  VISA_REQUEST,
  VISA_SUCCESS,
  VISA_FAIL,
  TRAVEL_REQUEST,
  TRAVEL_FAIL,
} from "../constants/AuthConstant";

const API = process.env.REACT_APP_API_PATH;

// ---------- COMMON DISPATCH WRAPPER ----------
const handleRequest = async (dispatch, type, callback) => {
  dispatch({ type });

  try {
    const res = await callback();
    return res.data;
  } catch (err) {
    const msg = err?.response?.data?.status?.message || "Something went wrong";
    toast.error(msg);

    dispatch({
      type: type.includes("VISA") ? VISA_FAIL : TRAVEL_FAIL,
      payload: msg,
    });

    throw err;
  }
};

// ---------- GET VISA + TRAVEL ----------
export const fetchVisaAndTravel = (candidateId) => async (dispatch) => {
  const res = await handleRequest(dispatch, VISA_REQUEST, () =>
    axios.get(`${API}/candidate/get_visa_information/${candidateId}`)
  );

  dispatch({
    type: VISA_SUCCESS,
    payload: res.data,
  });

  return res.data;
};

// ---------- ADD VISA ----------
export const addVisa = (formData) => async (dispatch) => {
  const res = await handleRequest(dispatch, VISA_REQUEST, () =>
    axios.post(`${API}/ebench/add_visa_information`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  );

  // toast.success("Visa Added Successfully");
  // dispatch(fetchVisaAndTravel(formData.get("candidateId"))); 
  return res;
};

// ---------- UPDATE VISA ----------
export const updateVisa = (visaId, formData, candidateId) => async (dispatch) => {
  dispatch({ type: VISA_REQUEST });

  try {
    const res = await axios.put(
      `${API}/ebench/update_visa/${visaId}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    dispatch({ type: VISA_SUCCESS, payload: res.data });

    toast.success("Visa updated successfully");

    dispatch(fetchVisaAndTravel(candidateId));

    return res.data;
  } catch (error) {
    dispatch({
      type: VISA_FAIL,
      payload: error?.response?.data || "Something went wrong",
    });

    toast.error(
      error?.response?.data?.status?.message || "Failed to update visa"
    );

    throw error;
  }
};

// ---------- DELETE VISA ----------
export const deleteVisa = (visaId, candidateId) => async (dispatch) => {
  await handleRequest(dispatch, VISA_REQUEST, () =>
    axios.delete(`${API}/candidate/delete_visa/${visaId}`)
  );

  toast.success("Visa Deleted");
  dispatch(fetchVisaAndTravel(candidateId));
};

// ---------- ADD TRAVEL ----------
export const addTravel = (data) => async (dispatch) => {
  const res = await handleRequest(dispatch, TRAVEL_REQUEST, () =>
    axios.post(`${API}/candidate/add_visa_information`, data)
  );

  toast.success("Travel Entry Added");
  dispatch(fetchVisaAndTravel(data.candidateId));
  return res;
};

// ---------- UPDATE TRAVEL ----------
export const updateTravel = (travelId, data) => async (dispatch) => {
  await handleRequest(dispatch, TRAVEL_REQUEST, () =>
    axios.put(`${API}/candidate/update_travel/${travelId}`, data)
  );

  toast.success("Travel Updated");
  dispatch(fetchVisaAndTravel(data.candidateId));
};

// ---------- DELETE TRAVEL ----------
export const deleteTravel = (travelId, candidateId) => async (dispatch) => {
  await handleRequest(dispatch, TRAVEL_REQUEST, () =>
    axios.delete(`${API}/candidate/delete_travel/${travelId}`)
  );

  toast.success("Travel Record Deleted");
  dispatch(fetchVisaAndTravel(candidateId));
};
